const Stack = () => {
  const stackItems = [
    {
      emoji: '🧠',
      title: 'Custom AI',
      description: 'Flexible intelligence modules to power strategic and investment decisions.',
      features: [
        'Proactive insight generation',
        'Opportunity detection',
        'Media & signal monitoring',
        'ESG profiling',
      ],
    },
    {
      emoji: '⚙️',
      title: 'Costs AI',
      description: 'Designed for procurement, finance, and supply chain pricing foresight.',
      features: [
        'Increase transparency',
        'Proactive forecasts',
        'Boost planning & budgeting',
        'Supply chain visibility',
      ],
    },
    {
      emoji: '🤝',
      title: 'Negotiation AI',
      description: 'A smart evaluation layer to enhance supplier discussions.',
      features: [
        'Automated power assessment',
        '360° supplier scorecards',
        'Forward-looking modelling',
        'Tail spend optimization',
      ],
    },
  ]

  return (
    <section id="stack" className="py-24 bg-brand-dark text-white relative overflow-hidden scroll-mt-20">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'radial-gradient(#4b5563 1px, transparent 1px)',
          backgroundSize: '30px 30px',
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-blue-500 font-bold tracking-widest uppercase text-sm mb-2">
            Our Technology
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold">The Simple Stack</h3>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            Platform agnostic solutions built with speed, precision, and business value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stackItems.map((item, idx) => (
            <div
              key={idx}
              className={`bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-all duration-300 ${
                idx === 1 ? 'transform md:-translate-y-4' : ''
              }`}
            >
              <div className="text-3xl mb-4">{item.emoji}</div>
              <h4 className="text-2xl font-bold mb-4">{item.title}</h4>
              <p className="text-gray-400 text-sm mb-6 min-h-[40px]">{item.description}</p>
              <ul className="space-y-3 text-sm text-gray-300">
                {item.features.map((feature, fIdx) => (
                  <li key={fIdx} className="flex items-start">
                    <span className="text-blue-500 mr-2">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Stack
